module.exports = __webpack_public_path__ + "static/media/notification.972c97d9.mp3";